import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Locations_ds_get_shipment_count_by_warehouse_by_userService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { userName?: string, dayQualifier?: number }): 
  Promise<{ result: { ShipmentCount?: number, ExpectedWarehouseId?: number } }> 
  {
    let url = `${environment.backendUrl}api/Locations/datasources/ds_get_shipment_count_by_warehouse_by_user/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      userName?: string, dayQualifier?: number    }) {
      return false;
    }
}
